import React from "react";
import { Facebook, Twitter, Instagram, Settings } from "lucide-react";
import LogoImage from '../../../Images/Logo.svg';

export default function Footer() {
  return (
    <footer className="w-full bg-gradient-to-b from-[#4BA3C3] to-[#2E7FA3] text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-[1200px] mx-auto">

        {/* Main Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-8">
          
          {/* Brand Section */}
          <div className="flex items-start">
            <img src={LogoImage} alt="SkillMD Logo" className="w-28 sm:w-32 md:w-36 h-auto" />
          </div>

          {/* Support Section */}
          <div>
            <h3 className="text-white font-semibold text-base mb-4">Support</h3>
            <ul className="space-y-2">
              <li><a href="#support" className="text-[#B3D9E8] text-sm hover:text-white transition-colors">Our Instructors</a></li>
              <li><a href="#contact" className="text-[#B3D9E8] text-sm hover:text-white transition-colors">Contact Us</a></li>
              <li><a href="#privacy" className="text-[#B3D9E8] text-sm hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="#terms" className="text-[#B3D9E8] text-sm hover:text-white transition-colors">Terms Conditions</a></li>
              <li><a href="#courses" className="text-[#B3D9E8] text-sm hover:text-white transition-colors">Our Courses</a></li>
            </ul>
          </div>

          {/* Useful Links Section */}
          <div>
            <h3 className="text-white font-semibold text-base mb-4">Useful Link</h3>
            <ul className="space-y-2">
              <li><a href="#about" className="text-[#B3D9E8] text-sm hover:text-white transition-colors">About Us</a></li>
              <li><a href="#overview" className="text-[#B3D9E8] text-sm hover:text-white transition-colors">Overview</a></li>
              <li><a href="#instructor" className="text-[#B3D9E8] text-sm hover:text-white transition-colors">Instructor</a></li>
              <li><a href="#join" className="text-[#B3D9E8] text-sm hover:text-white transition-colors">Join Us</a></li>
              <li><a href="#news" className="text-[#B3D9E8] text-sm hover:text-white transition-colors">Our News</a></li>
            </ul>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="text-white font-semibold text-base mb-4">Contact</h3>
            <p className="text-[#B3D9E8] text-sm mb-2">88 Brooklyn Street, New York USA</p>
            <a href="mailto:needhelp@company.com" className="text-[#B3D9E8] text-sm block mb-1 hover:text-white transition-colors">needhelp@company.com</a>
            <a href="tel:+18806562121" className="text-[#B3D9E8] text-sm block hover:text-white transition-colors">+1 889 6562 121</a>
          </div>

          {/* Social Icons Section */}
          <div className="flex lg:justify-end gap-3">
            <a href="#facebook" className="w-10 h-10 bg-[#4A8FAA] rounded-full flex items-center justify-center text-white hover:bg-white hover:text-[#2E7FA3] transition-all transform hover:-translate-y-1">
              <Facebook size={20} />
            </a>
            <a href="#twitter" className="w-10 h-10 bg-[#4A8FAA] rounded-full flex items-center justify-center text-white hover:bg-white hover:text-[#2E7FA3] transition-all transform hover:-translate-y-1">
              <Twitter size={20} />
            </a>
            <a href="#instagram" className="w-10 h-10 bg-[#4A8FAA] rounded-full flex items-center justify-center text-white hover:bg-white hover:text-[#2E7FA3] transition-all transform hover:-translate-y-1">
              <Instagram size={20} />
            </a>
            <a href="#settings" className="w-10 h-10 bg-[#4A8FAA] rounded-full flex items-center justify-center text-white hover:bg-white hover:text-[#2E7FA3] transition-all transform hover:-translate-y-1">
              <Settings size={20} />
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-[#6DB8D8] my-8"></div>

        {/* Bottom Section */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
          <p className="text-[#B3D9E8] text-xs text-center sm:text-left">
            © 2025 SkillsMD | All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}
